// ── Helpers de tiempo ─────────────────────────────────────────────────────────

export const timeToMin = (hhmm) => {
  const [h, m] = hhmm.split(':').map(Number);
  return h * 60 + m;
};

export const minToHHMM = (totalMin) => {
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
};

export const calcEndTime  = (start, durMin) => minToHHMM(timeToMin(start) + durMin);
export const calcDuration = (start, end)    => timeToMin(end) - timeToMin(start);

/**
 * Calcula el layout de citas solapadas para una columna de tiempo.
 * Retorna un Map<aptId, { col: number, total: number }>.
 *
 * col   = columna 0-based asignada a la cita (izquierda → derecha)
 * total = número total de columnas en el grupo de solapamiento
 *
 * Funciona como Google Calendar: citas simultáneas se muestran lado a lado.
 */
export const computeOverlapLayout = (apts) => {
  if (!apts || apts.length === 0) return new Map();

  // Ordenar por hora de inicio; en empate, mayor duración primero
  const sorted = [...apts].sort((a, b) => {
    const diff = timeToMin(a.hora_inicio) - timeToMin(b.hora_inicio);
    if (diff !== 0) return diff;
    const durA = a.hora_fin ? timeToMin(a.hora_fin) - timeToMin(a.hora_inicio) : 30;
    const durB = b.hora_fin ? timeToMin(b.hora_fin) - timeToMin(b.hora_inicio) : 30;
    return durB - durA;
  });

  // Asignar columna a cada cita (sweep-line)
  const colEnd = []; // colEnd[i] = minuto de fin de la última cita en columna i
  const assigned = new Map(); // id → col

  for (const apt of sorted) {
    const startMin = timeToMin(apt.hora_inicio);
    const endMin   = apt.hora_fin ? timeToMin(apt.hora_fin) : startMin + 30;

    // Columna libre más baja
    let col = 0;
    while (colEnd[col] !== undefined && colEnd[col] > startMin) col++;
    colEnd[col] = endMin;
    assigned.set(apt.id, { col, endMin });
  }

  // Calcular total de columnas para cada cita (máx columna ocupada en su grupo + 1)
  const result = new Map();
  for (const apt of sorted) {
    const startMin = timeToMin(apt.hora_inicio);
    const endMin   = apt.hora_fin ? timeToMin(apt.hora_fin) : startMin + 30;
    const col      = assigned.get(apt.id).col;

    let maxCol = col;
    for (const other of sorted) {
      if (other.id === apt.id) continue;
      const oStart = timeToMin(other.hora_inicio);
      const oEnd   = other.hora_fin ? timeToMin(other.hora_fin) : oStart + 30;
      if (oStart < endMin && oEnd > startMin) {
        maxCol = Math.max(maxCol, assigned.get(other.id).col);
      }
    }
    result.set(apt.id, { col, total: maxCol + 1 });
  }

  return result;
};
